import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const showMessageIfInvoiceWasGeneratedAutomatically = (response) => {
  if (!response.data.invoiceGenerated) {
    return MessageActions.addMessageBoxError(
      'La factura no fue generada automáticamente'
    );
  }
  return {
    'type': ActionTypes.INVOICE_GENERATED,
  };
};

export const clearScanningInfo = () => ({
  'type': ActionTypes.CLEAR_SCANNING_INFO,
});

export const clearScanningItems = () => ({
  'type': ActionTypes.CLEAR_SCANNING_ITEMS,
});

export const fetchAgenciesList = (params = {}) => apiActionCreator({
  'endpoint': `/pickingVerifications/agencies${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_AGENCIES_LIST,
    ActionTypes.FETCHED_AGENCIES_LIST,
    [
      ActionTypes.FETCHED_AGENCIES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchAgency = (agency) => apiActionCreator({
  'endpoint': `/pickingVerifications/dealers/${agency.dealerIdentification}/agencies/${agency.code}/status`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_AGENCY,
    {
      'type': ActionTypes.FETCHED_AGENCY,
      'payload': {agency},
    },
    [
      ActionTypes.FETCHED_AGENCY_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchReplacementPart = (agency, sequence, index) => apiActionCreator({
  'endpoint': `/pickingVerifications/dealers/${agency.dealerIdentification}/` +
  `agencies/${agency.code}/sequences/${sequence}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_REPLACEMENT_PART,
    {
      'type': ActionTypes.FETCHED_REPLACEMENT_PART,
      'payload': index,
    },
    [
      {
        'type': ActionTypes.FETCHED_REPLACEMENT_PART_FAILED,
        'payload': index,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveLineInfo = ({agency, sequence}, index, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/pickingVerifications/dealers/${agency.dealerIdentification}/` +
      `agencies/${agency.code}/sequences/${sequence}`,
      'authenticated': true,
      'types': [
        ActionTypes.SAVING_LINE_INFO,
        [
          () => {
            dispatch(fetchAgency(agency));
            return {
              'type': ActionTypes.SAVED_LINE_INFO,
              'payload': index,
            };
          },
          (response) => showMessageIfInvoiceWasGeneratedAutomatically(response),
        ],
        [
          ActionTypes.SAVED_LINE_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    }),
  );
};

export const fetchScanningPendingItemsList = (agency, warehouse = 'CPD') => apiActionCreator({
  'endpoint': `/pickingVerifications/dealers/${agency.dealerIdentification}/` +
  `agencies/${agency.code}/orders?status=pending&warehouse=${warehouse}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PENDING_ITEMS_LIST,
    ActionTypes.FETCHED_PENDING_ITEMS_LIST,
    [
      ActionTypes.FETCHED_PENDING_ITEMS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchScanningReviewedItemsList = (agency, warehouse = 'CPD') => apiActionCreator({
  'endpoint': `/pickingVerifications/dealers/${agency.dealerIdentification}/` +
  `agencies/${agency.code}/orders?status=verified&warehouse=${warehouse}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_REVIEWED_ITEMS_LIST,
    ActionTypes.FETCHED_REVIEWED_ITEMS_LIST,
    [
      ActionTypes.FETCHED_REVIEWED_ITEMS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchPickingWareHouseDeniedList = (agency, params = {}) => apiActionCreator({
  'endpoint': `/pickingVerifications/dealers/${agency.dealerIdentification}/agencies/${agency.code}/denials` +
    `${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST,
    ActionTypes.FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST,
    [
      ActionTypes.FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchReplacementPartOrderRequestsInfo = (replacementPart, agency, dealer) => apiActionCreator({
  'endpoint':
    `/pickingVerifications/dealers/${dealer}/agencies/${agency}/parts/${replacementPart}/ordersInfo`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_REPLACEMENT_PART_ORDER_REQUESTS_INFO,
    ActionTypes.FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO,
    [
      ActionTypes.FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveReplacementPartWarehouseDenialCause = ({agency, dealer}, data, params = {}) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/pickingVerifications/dealers/${dealer}/agencies/${agency}/denials`,
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE,
      [
        () => {
          dispatch(fetchPickingWareHouseDeniedList({'dealerIdentification': dealer, 'code': agency}, params));
          return {'type': ActionTypes.SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE};
        },
        MessageActions.addMessageBoxInfo('Causa de warehouse denied guardada satisfactoriamente'),
      ],
      [
        ActionTypes.SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  }));
};

export const createPartSaleInvoice = ({agency, dealer}) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/transactions/parts/sales/dealers/${dealer}/agencies/${agency}`,
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_SALE_INVOICE,
      [
        () => {
          dispatch(fetchAgenciesList());
          return {'type': ActionTypes.CREATED_SALE_INVOICE};
        },
        (response) => {
          return MessageActions.addMessageBoxInfo(response.data.message);
        },
      ],
      [
        ActionTypes.CREATED_SALE_INVOICE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
  }));
};
